<!-- компонент: диалог создания/восстановления бэкапа -->
<template>
	<div v-show="dialogVisible" @click="hideDialog" class="modal-mask">
		<div class="modal-wrapper">
			<div class="modal-container" @click.stop>

				<div class="modal-header">
					<span class="font-weight-500">
						{{ type === 'create-backup' ? 'service/creating_backup' : 'service/restore' | ftc }}
					</span>
					<button type="button" class="close" @click="hideDialog">&times;</button>
				</div>

				<div class="modal-body">
					<form class="w5-from">
						<fieldset>
							<div class="w5-form-row">
								<Field
									:isVisibleRow="true"
									:listBlockToOut="true"
									:Field="accountField"
									:removeRightPadding="true"
									:fieldInModal="true"
									:action="type"
									crud="backupModalDialog"
									v-model="accountValue"
									@input="accountChanged" />
							</div>
							<div class="w5-form-row">
								<Field
									:isVisibleRow="true"
									:Field="serviceField"
									:removeRightPadding="true"
									:fieldInModal="true"
									:listBlockToOut="1"
									:action="type"
									class="display-grid"
									crud="backupModalDialog"
									v-model="serviceValue"
									@input="serviceChanged" />
							</div>
							<div v-show="createBackupText" class="w5-form-row">
								<span v-withSafeTags="localeFtc(createBackupText)"></span>
							</div>
							<div v-show="notPossibleText" class="w5-form-row">
								<span class="warrning" v-withSafeTags="localeFtc(notPossibleText)"></span>
							</div>
							<div v-if="type === 'restore-backup' && restoreBackupText && (!notPossibleText && !createBackupText)" class="w5-form-row">
								<span class="warrning" v-withSafeTags="localeFtc(restoreBackupText)"></span>
							</div>
						</fieldset>
					</form>
				</div>

				<div class="modal-footer">
					<span class="btn btn-submit pull-right" @click="dialogAction">
						{{ type === 'create-backup' ? 'service/backup_create' : 'service/backup_restore' | ftc }}
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Vue from 'vue'
import Helper from '@/helper/helper'
import Field from '@/components/elements/formfield'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'dialogBackup',

	//=========================================================================
	// свойства переданные родителем
	//=========================================================================
	props: {
		type: String,
		accountId: [Boolean, Number],
		backupId: [Boolean, Number],
		backupName: {
			type: String
		},
		userType: {
			type: String,
			required: true
		},
		visible: {
			type: Boolean,
			required: true
		}
	},

	//=========================================================================
	// свойства компонента
	//=========================================================================
	data() {
		return {
			dialogVisible: this.visible,

			accountValue: false,
			serviceValue: false,

			createBackupText: '',
			notPossibleText: '',
			restoreBackupText: '',

			accountField: {
				_field_name: 'account_id',
				_visible: true,
				_is_modal: true,
				_storeValue: null,
				required: true,
				title: 'account/account',
				type: 'list',
				url: '/service/create?search=account&q='
			},
			serviceField: {
				_field_name: 'service_id',
				_visible: true,
				_is_modal: true,
				required: true,
				title: 'service/vds',
				type: 'list',
				list: []
			}
		}
	},

	//=========================================================================
	// обработчик события: компонент создан (все вычеслено)
	//=========================================================================
	created() {
		this.accountField._visible = this.userType === 'admin' &&
			this.type === 'create-backup' && !this.accountId
		if (this.accountId)
			this.getServiceList()
	},

	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// подписка на получение данных о полях формы
		EventBus.$on('w5-backup-dialog-fields', this.pareFormFields)
	},

	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// описка от события
		EventBus.$off('w5-backup-dialog-fields', this.pareFormFields)
	},

	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		// инициализация события "onClose" - закрыть диалог
		hideDialog() {
			this.$emit('onClose')
		},
		// инициализация события "onAction" - запустить соответствующий процесс
		dialogAction() {
			if (!this.serviceValue || this.notPossibleText) return

			this.$emit('onAction', {
				'account': this.accountValue,
				'service': this.serviceValue
			})
		},
		// пришли данные формы
		pareFormFields(fields) {
			if (!fields) return

			// account
			if (fields.account_id)
			{
				this.$set(this.accountField, 'title', fields.account_id.title)
				this.$set(this.accountField, 'url', fields.account_id.url)
			}

			// service
			if (fields.service_id)
			{
				this.$set(this.serviceField, 'title', fields.service_id.title)
			}
		},
		// запрос списка услуг
		getServiceList() {
			this.serviceField.list = []
			this.serviceValue = false
			this.createBackupText = ''
			this.notPossibleText = ''

			let _paramsGet = {}

			if (this.type === 'create-backup')
			{
				_paramsGet.search = 'service_backup'

				if (this.accountId && this.accountId !== true)
					_paramsGet.account_id = this.accountId
				if (this.accountValue)
					_paramsGet.account_id = this.accountValue
			}
			else
			{
				_paramsGet.search = 'service_restore'
				_paramsGet.backup_id = this.backupId
			}

			this.$http.get(Vue.APIServerUrl + '/service/create', { 'params': _paramsGet })
			.then(res => {
				let _dt = res &&
					res.data &&
					typeof res.data === 'object' ? res.data : false

				if (_dt && _dt.status === 'ok' && _dt.result)
				{
					this.serviceField.list = _dt.result
					return
				}
				throw new Error(res)
			})
			.catch(error => this.$emit('onError', error))
		},
		// обработчик: изменилось значение аккаунта
		accountChanged(value) {
			// service
			if (this.serviceField._visible)
				this.getServiceList()
		},
		// обработчик: изменилось значение услуги
		serviceChanged(value) {
			if (!value ||
				!this.serviceField.list ||
				!this.serviceField.list.length)
				return

			this.restoreBackupText = ''

			this.serviceField.list.some(item => {
				if (String(item.id) === String(value))
				{
					if (item.name && this.backupName)
					{
						this.restoreBackupText = this.localeFtc('service/restore_backup_info')
							.replace('{server}', item.name)
							.replace('{backup}', this.backupName)
					}

					if (item.data && item.data.extdisk && item.data.extdisk.attached === true)
					{
						if (this.restoreBackupText) this.restoreBackupText += '<br><br>' + this.localeFtc('service/reboot_warning')
						else this.restoreBackupText = this.localeFtc('service/reboot_warning')
					}

					if (!item.active || !item.enable)
					{
						let _errorMessage = this.type === 'create-backup'
							? this.localeFtc('service/creating_backup_vds_not_possible')
							: this.localeFtc('service/backup_error')

						this.createBackupText = ''
						this.notPossibleText = _errorMessage
					}
					else
					{
						this.notPossibleText = ''
						this.createBackupText = ''

						if (this.type === 'create-backup')
						{
							let _size = 0
							let _for = ''
							let _wholeCost = item.cost

							if (item &&
								item.data &&
								item.data.plan &&
								item.data.plan.data &&
								item.data.plan.data.disk)
							{
								_for = item.data.plan.data.disk.for

								if ('total' in item.data.plan.data.disk)
									_size = parseFloat(item.data.plan.data.disk.total)
								else if ('value' in item.data.plan.data.disk)
									_size = parseFloat(item.data.plan.data.disk.value)
							}

							if ('cost' in item) {
								let _val = parseFloat(item.cost)
								if (!isNaN(_val) && !isNaN(_size)) {
									_wholeCost = _val// * _size
								}
							}

							this.createBackupText = _size
								? this.localeFtc(
									'service/creating_backup_cost <b>main/ruble</b>' +
									' / <b>{period}</b> / <b>{size}</b>'
									)
									.replace('{cost}', Helper.String2Money(Helper.FormatMoney2(_wholeCost, 2)))
									.replace('{period}', this.localeFtc(item.period))
									.replace('{size}', _size + ' ' + this.localeFtc(_for))
								: this.localeFtc(
									'service/creating_backup_cost <b>main/ruble</b>' +
									' / <b>{period}</b>'
									)
									.replace('{cost}', item.cost)
									.replace('{period}', this.localeFtc(item.period))
						}
					}
					return true
				}
			})
		}
	},

	//=========================================================================
	// наблюдаем за свойствами
	//=========================================================================
	watch: {
		type: {
			handler: function(type) {
				this.accountField._visible = this.userType === 'admin' &&
					type === 'create-backup' && !this.accountId
			},
			immediate: true
		},
		accountId: {
			handler: function(account) {
				this.accountField._visible = this.userType === 'admin' &&
					this.type === 'create-backup' && !account
			},
			immediate: true
		},
		visible: {
			handler: function(visible) {
				this.accountValue = false
				this.serviceValue = false
				this.createBackupText = ''
				this.notPossibleText = ''
				this.restoreBackupText = ''

				if (visible && this.accountId)
					this.getServiceList()

				if (visible && this.type === 'create-backup')
				{
					let _accData = window && window.sessionStorage ? window.sessionStorage.getItem('create-backup') : null
					if (_accData)
					{
						window.sessionStorage.removeItem('create-backup')
						let _json = null
						try {
							_json = JSON.parse(_accData)
						}
						catch (err) {}
						if (_json && _json.account_id)
						{
							this.$nextTick(() => {
								EventBus.$emit('w5-set-list-field-value', {
									name: 'account_id',
									value: {
										id: _json.account_id,
										name: 'a' + _json.account_id
									}
								})
							})
						}
					}
				}

				this.dialogVisible = visible
			},
			immediate: true
		}
	},

	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: { Field }
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.warrning {
	position: relative;
    padding: 10px;
    border-radius: 4px;
    background: #fff5ee;
    border: 1px solid #f9caa7;
    color: #333;
	width: 100%;
}

.warrning::before, .warrning::after {
	content: '';
	position: absolute;
	left: 20px; top: -10px;
	border: 5px solid transparent;
	border-bottom: 5px solid #f9caa7;
}

.warrning::after {
	border-bottom: 5px solid #fff5ee;
	top: -8px;
}
</style>



// WEBPACK FOOTER //
// backupdialog.vue?be73ed3e